const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the users avatar display component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('avatarDisplay', ['cssUrl', function (cssUrl) {
    return {
      restrict: 'E',
      scope: {
        user: '=',
        nonUser: '@',
        name: '=',
        image: '=',
        watchItem: '@',
        allowEdit: '@?',
        onRemove: '&?',
        onUpload: '&?'
      },
      replace: true,
      template: require('../../templates/directives/avatar-display.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.initials = '';
        self.image = null;

        self.makeInitials = function() {
          self.initials = '';
          var names;
          var handled = false;
          if ($scope.nonUser && $scope.name) {
            handled = true;
            names = $scope.name.split(' ');
          }
          if (!$scope.nonUser && $scope.user && $scope.user.first_name) {
            handled = true;
            names = [$scope.user.first_name];
            if ($scope.user.last_name) {
              names.push($scope.user.last_name);
            }
          }
          if (!handled || !names || !names.length) {
            return;
          }

          self.initials += names[0][0];
          if (names.length > 1) {
            self.initials += names[names.length - 1][0];
          }
          self.initials = self.initials.toUpperCase();
        };

        // The background-image value for ng-style, or '' to show the initials instead.
        self.makeImage = function(imageUrl) {
          return cssUrl(imageUrl);
        }

        self.makeInitials();

        if ($scope.nonUser) {
          self.image = self.makeImage($scope.image);
          if (!$scope.name || $scope.watchItem) {
            var nameWatch = $scope.$watch('name', function(newVal, oldVal) {
              if (!newVal && !oldVal || newVal === oldVal) {
                return;
              }
              self.makeInitials();
              if (!$scope.watchItem) {
                nameWatch();
              }
            });
          }
          if (!$scope.image || $scope.watchItem) {
            var imageWatch = $scope.$watch('image', function(newVal, oldVal) {
              if (!newVal && !oldVal || newVal === oldVal) {
                return;
              }
              self.image = self.makeImage($scope.image);
              if (!$scope.watchItem) {
                imageWatch();
              }
            });
          }
          return;
        }

        if ($scope.user) {
          self.image = self.makeImage($scope.user.image);
        }

        if ($scope.user && !$scope.watchItem) {
          return;
        }

        var userWatch = $scope.$watch('user', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          if (oldVal && newVal.first_name === oldVal.first_name && newVal.last_name === oldVal.last_name && newVal.image === oldVal.image) {
            return;
          }
          if ($scope.user) {
            self.makeInitials();
            self.image = self.makeImage($scope.user.image);
            if ($scope.user && !$scope.watchItem) {
              userWatch();
            }
          }
        }, true);
      }],
      controllerAs: 'avatarDisplay'
    };
  }]);


